<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    height: String,
    labels: Array,
    datasets: Array
  },
  watch: {
    datasets: function () {
      // this._chart.destroy();
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.datasets
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: 'right'
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  drawOnChartArea: false
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  maxTicksLimit: 5
                },
                gridLines: {
                  display: true
                }
              }
            ]
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          },
          tooltips: {
            enabled: true,
            intersect: true,
            mode: 'point',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return {
                  borderColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor,
                  backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor
                }
              }
            }
          }
        }
      )
    }
  },
  mounted () {
    // Overwriting base render method with actual data.
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.datasets
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'right'
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        },
        tooltips: {
          enabled: true,
          intersect: true,
          mode: 'point',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return {
                backgroundColor:
                  chart.data.datasets[tooltipItem.datasetIndex].backgroundColor
              }
            }
          }
        }
      }
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/BarExample.vue